
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SliderSection from './components/SliderSection';
import ContentSection from './components/ContentSection';
import ProfileSection from './components/ProfileSection';
import { SchemaOrg } from '../../utils/seo';

const Home = () => {
  return (
    <div className="min-h-screen">
      <SchemaOrg
        type="Organization"
        data={{
          name: 'ナナイロ',
          description: 'スロット演者事業「ナナイロ」は、パチンコ・スロット業界で活動する演者グループです。ホール来店、実戦動画配信、イベント出演など幅広い活動を行い、質の高いコンテンツをお届けします。',
          url: '/',
          logo: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/vite.svg`,
          sameAs: [],
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: 'ナナイロ | スロット演者事業',
          description: 'スロット演者事業「ナナイロ」は、パチンコ・スロット業界で活動する演者グループです。ホール来店、実戦動画配信、イベント出演など幅広い活動を行い、質の高いコンテンツをお届けします。',
          url: '/',
        }}
      />
      <Header />
      <main className="pt-20">
        <HeroSection />
        <SliderSection />
        <ContentSection />
        <ProfileSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
